import React from 'react';
import PropTypes from 'prop-types';
import { Trans } from 'react-i18next';

class BasicCheckbox extends React.Component {
  static propTypes = {
    touched: PropTypes.any,
    errors: PropTypes.any,
    values: PropTypes.any,
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    help: PropTypes.string,
    noFormGroup: PropTypes.bool,
    options: PropTypes.array,
    setFieldValue: PropTypes.func
  };

  _handleChange(option) {
    const { name, setFieldValue, values } = this.props;
    const tempValues = values[name];
    const idx = tempValues.indexOf(option.value);
    if (idx !== -1) {
      tempValues.splice(idx, 1);
    } else {
      tempValues.push(option.value);
    }

    setFieldValue(name, tempValues);
  }

  render() {
    const {
      touched,
      errors,
      values,
      name,
      label,
      help,
      noFormGroup,
      options
    } = this.props;

    return (
      <div
        className={
          touched[name] && errors[name]
            ? (noFormGroup ? '' : 'form-group m-form__group ') + 'has-danger'
            : noFormGroup
            ? ''
            : 'form-group m-form__group '
        }
      >
        {label && <label>{label}</label>}
        <div className="m-checkbox-list">
          {options.map(option => (
            <label className="m-checkbox" key={name + '_' + option.value}>
              <input
                type="checkbox"
                name={name + '_' + option.value}
                id={name}
                onChange={() => this._handleChange(option)}
                checked={values[name].indexOf(option.value) > -1}
              />{' '}
              <Trans>{option.title}</Trans>
              <span />
            </label>
          ))}
        </div>
        {help && (
          <span className="m-form__help">
            <Trans>{help}</Trans>
          </span>
        )}
        {touched[name] && errors[name] && (
          <div className="form-control-feedback">
            <Trans>{errors[name]}</Trans>
          </div>
        )}
      </div>
    );
  }
}

export default BasicCheckbox;
